module.exports = __webpack_public_path__ + "static/media/19ESCAP43.db34be48.jpg";